import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { PlaceSearchResult } from '@app/components/pr-form/pr-input-map/pr-input-map.component';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'owner-address',
    templateUrl: './owner-address.component.html',
    styleUrls: ['./owner-address.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class OwnerAddressComponent implements OnInit {
  @Input() derrors = false;
  @Input() isSwisslifeProduct = false;
  countries: any[];
  departments: any[];
  toValue: PlaceSearchResult = { address: '' };

  constructor(
    private controlContainer: FormGroupDirective,
    private referenceDao: ReferenceDao,
  ) {}

  ngOnInit() {
    combineLatest([this.referenceDao.getCountries()])
      .pipe(untilDestroyed(this))
      .subscribe(([countries]) => {
        this.countries = countries;
      });
  }
  get form() {
    return this.controlContainer.form;
  }
}
